import { z } from "zod";
import type { ServiceListItem, ServicesListResponse } from "@/services/service-master.service";

export type { ServicesListResponse };
export type ServiceListEntity = ServiceListItem;

export const serviceMasterFilterSchema = z.object({
  Nombre: z.string().optional(),
  Categoria: z.any().optional(),
  UnidadCotizacion: z.any().optional(),
  Activo: z.any().optional(),
});
